import { toast } from 'sonner'
import { SettingCell } from '@/components/setting-cell'
import { Switch } from '@/components/ui/switch'
import { useActorName } from '@/hooks/use-actor-name'
import { formatApiErrorMessage } from '@/lib/api-error'
import { useManufacturerDataAgent, useSetLeadTimeCheck } from './hooks'
import { leadTimeCheckLine } from './model'

/**
 * The weekly lead-time check switch beside the preferred source's lead time (USA-1474): on or off per
 * manufacturer, with when the next one goes out or why it won't.
 */
export function LeadTimeCheckSetting({ manufacturerUuid }: { manufacturerUuid: string }) {
  const agent = useManufacturerDataAgent(manufacturerUuid)
  const setCheck = useSetLeadTimeCheck(manufacturerUuid)
  const status = agent.data?.lead_time_check
  const actorName = useActorName()
  const line = status && !setCheck.isPending ? leadTimeCheckLine(status, actorName) : null
  const note =
    line?.state === 'scheduled' ? `Next: ${line.when}` : line?.state === 'blocked' ? line.reason : (line?.reason ?? null)
  return (
    <SettingCell
      label="Weekly lead-time check"
      htmlFor="lead-time-check"
      below={note ? <p className="mt-0.5 break-words text-xs text-muted-foreground">{note}</p> : null}
    >
      <Switch
        id="lead-time-check"
        checked={status?.enabled ?? false}
        disabled={!status}
        onCheckedChange={(checked) =>
          setCheck.mutate(checked, {
            onError: (error) => toast.error(formatApiErrorMessage('Lead-time check not changed', error)),
          })
        }
      />
      <span className="text-sm">{status ? (status.enabled ? 'On' : 'Off') : ''}</span>
    </SettingCell>
  )
}
